import type { PriceTuple, TotalPrice } from '../state/types';

export interface OptionRecord {
  id: number;
  msrp: number;
  salePrice: number;
  dealerNet: number;
}

export interface PricingConfig {
  exchangeRate: number;
  dealerBaseMargin: number;
  dealerOptionsMargin: number;
}

/**
 * Pure function: calculates the total price from all components.
 * No DOM access — trivially unit-testable.
 */
export function calculateTotal(
  basePrice: PriceTuple,
  enginePrice: PriceTuple,
  colorPrice: PriceTuple,
  selectedOptions: OptionRecord[],
  _config: PricingConfig
): TotalPrice {
  const optionsTotals: PriceTuple = selectedOptions.reduce(
    (acc, opt) => ({
      msrp: acc.msrp + opt.msrp,
      salePrice: acc.salePrice + opt.salePrice,
      dealerNet: acc.dealerNet + opt.dealerNet,
    }),
    { msrp: 0, salePrice: 0, dealerNet: 0 }
  );

  return {
    msrp: basePrice.msrp + enginePrice.msrp + colorPrice.msrp + optionsTotals.msrp,
    salePrice: basePrice.salePrice + enginePrice.salePrice + colorPrice.salePrice + optionsTotals.salePrice,
    dealerNet: basePrice.dealerNet + enginePrice.dealerNet + colorPrice.dealerNet + optionsTotals.dealerNet,
    basePrice,
    enginePrice,
    colorPrice,
    optionsPrice: optionsTotals,
  };
}

/**
 * Apply exchange rate to a price tuple.
 */
export function applyExchangeRate(price: PriceTuple, rate: number): PriceTuple {
  return {
    msrp: Math.round(price.msrp * rate * 100) / 100,
    salePrice: Math.round(price.salePrice * rate * 100) / 100,
    dealerNet: Math.round(price.dealerNet * rate * 100) / 100,
  };
}
